@if (isOpen) {
<div [ngClass]="[
  'fixed inset-0 flex items-center justify-center overflow-y-auto modal px-4 sm:px-6 modal-overlay-animated',
  isFullscreen ? 'z-[100000]' : (isNested ? 'z-[200000]' : 'z-99999')
]">
  <!-- Backdrop -->
  @if (!isFullscreen) {
  <div 
      class="fixed inset-0 h-full w-full bg-black/50 backdrop-modal backdrop-animated"
      (click)="onBackdropClick($event)">
  </div>
  }

  <!-- Modal Content -->
  <div
    [ngClass]="[
      isFullscreen
        ? 'w-full h-full'
        : 'relative w-full max-w-2xl mx-auto bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 modal-content-animated',
      className
    ]"
    [ngStyle]="!isFullscreen ? {'max-width': maxWidth} : null"
    (click)="onContentClick($event)"
  >

    @if (isFullscreen) {
      @if (showCloseButton) {
      <button
              (click)="close.emit()"
              class="fixed right-6 top-6 z-999 flex h-10 w-10 items-center justify-center modal-close-btn bg-gray-100 text-gray-500 transition-colors hover:bg-gray-200 hover:text-gray-800 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6.04289 16.5413C5.65237 16.9318 5.65237 17.565 6.04289 17.9555C6.43342 18.346 7.06658 18.346 7.45711 17.9555L11.9987 13.4139L16.5408 17.956C16.9313 18.3466 17.5645 18.3466 17.955 17.956C18.3455 17.5655 18.3455 16.9323 17.955 16.5418L13.4129 11.9997L17.955 7.4576C18.3455 7.06707 18.3455 6.43391 17.955 6.04338C17.5645 5.65286 16.9313 5.65286 16.5408 6.04338L11.9987 10.5855L7.45711 6.0439C7.06658 5.65338 6.43342 5.65338 6.04289 6.0439C5.65237 6.43442 5.65237 7.06759 6.04289 7.45811L10.5845 11.9997L6.04289 16.5413Z"
                fill="currentColor"></path>
        </svg>
      </button>
      }

      <div class="modal-full custom-scrollbar fixed top-0 left-0 flex flex-col justify-between w-full h-screen p-6 overflow-x-hidden overflow-y-auto bg-white dark:bg-gray-900 lg:p-10">
        @if (template) {
          <ng-container [ngTemplateOutlet]="template"></ng-container>
        } @else {
          <ng-content></ng-content>
        }
      </div>

    } @else {

      <div [ngClass]="['modal-scroll-container custom-scrollbar max-h-[90vh] overflow-auto relative', scrollClass]">

        @if (showCloseButton) {
        <button
                (click)="close.emit()"
                class="absolute right-6 top-6 z-50 flex h-10 w-10 items-center justify-center modal-close-btn bg-gray-100 text-gray-500 transition-colors hover:bg-gray-200 hover:text-gray-800 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.04289 16.5413C5.65237 16.9318 5.65237 17.565 6.04289 17.9555C6.43342 18.346 7.06658 18.346 7.45711 17.9555L11.9987 13.4139L16.5408 17.956C16.9313 18.3466 17.5645 18.3466 17.955 17.956C18.3455 17.5655 18.3455 16.9323 17.955 16.5418L13.4129 11.9997L17.955 7.4576C18.3455 7.06707 18.3455 6.43391 17.955 6.04338C17.5645 5.65286 16.9313 5.65286 16.5408 6.04338L11.9987 10.5855L7.45711 6.0439C7.06658 5.65338 6.43342 5.65338 6.04289 6.0439C5.65237 6.43442 5.65237 7.06759 6.04289 7.45811L10.5845 11.9997L6.04289 16.5413Z"
                  fill="currentColor"></path>
          </svg>
        </button>
        }

        <div>
          @if (template) {
            <ng-container [ngTemplateOutlet]="template"></ng-container>
          } @else {
            <ng-content></ng-content>
          }
        </div>

      </div>
    }

  </div>
</div>
}
